module.exports = __webpack_public_path__ + "1cc37b20808713b1c220dbf0da463c8a.svg";